var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity-bar",class:[_vm.type, _vm.mini ? 'mini' : '']},[_c('span',[_vm._v(_vm._s(_vm.typeText))]),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.timerText))])])}
var staticRenderFns = []

export { render, staticRenderFns }